package one.healthium.paywall.ui.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.bundle.components.BundleImage
import one.healthium.domain.paywall.models.PaywallImageView
import one.healthium.base.utils.current
import one.healthium.ui.common.utils.toContentScale

@Composable
fun PaywallImageView(model: PaywallImageView) {
    val config = model.configs.current() ?: return
    BundleImage(
        modifier = Modifier
            .fillMaxWidth()
            .height(config.height?.dp ?: 276.dp),
        name = config.imageName,
        contentScale = config.contentMode?.toContentScale()
    )
}
